<template>
  <div>
    <label
        v-if="label"
        :for="id"
        :class="`${errors.length ? 'text-error' : 'text-zinc-800'} mb-1.5 block leading-normal`"
    >
      {{ `${label}${required ? '*' : ''}` }}
    </label>

    <div class="relative">
      <textarea
          :id="id"
          v-model="localValue"
          :class="`${errors.length ? 'ring-error' : 'ring-gray-200'} w-full resize-none rounded-md border-0 bg-white px-3.5 py-2.5 font-normal text-zinc-800 shadow-[0px_1px_2px_0px_#2A33420D] ring-1 ring-inset placeholder:text-zinc-500 focus:ring-2 focus:ring-inset focus:ring-secondary disabled:cursor-not-allowed disabled:bg-zinc-100 disabled:text-zinc-500 disabled:placeholder:text-zinc-300`"
          :placeholder="placeholder"
          rows="5"
          :minlength="minLength"
          :maxlength="maxLength"
          :disabled="disabled"
          :required="required"
          @input="handleInput"
          @keydown.ctrl.enter.prevent="handleSave"
      />

      <button
          type="button"
          class="absolute bottom-3 right-2 inline-flex items-center hover:opacity-95 transition disabled:opacity-50 disabled:cursor-not-allowed "
          :disabled="isEmpty || disabled"
          @click="handleSave"
          aria-label="Save note"
      >
        <Icon name="send" class="size-8 !text-3xl text-primary disabled:text-gray-600" is-filled />
      </button>
    </div>

    <div v-if="errors.length" class="mt-2 space-y-1">
      <span
          v-for="(error, index) in errors"
          :key="index"
          class="block text-xs text-error"
      >
        {{ error }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';
import {Icon} from "@/components/global";

const props = defineProps({
  id: { type: String, required: true },
  label: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  minLength: { type: Number, default: 0 },
  maxLength: { type: Number, default: 1000 },
  required: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  value: { type: String, default: '' },
  errors: { type: Array, default: () => [] }
});

const emit = defineEmits(['update:value', 'save', 'update:errors']);

const localValue = ref(props.value);
watch(() => props.value, (v) => { localValue.value = v ?? ''; });

const isEmpty = computed(() => !localValue.value || !localValue.value.trim());

function handleInput() {
  emit('update:value', localValue.value);
  emit('update:errors', []);
}

function handleSave() {
  if (isEmpty.value) return;
  emit('save', localValue.value);
}
</script>
